import MenuSidebarContainer from './container'

export default MenuSidebarContainer
